<template>
  <div>
    <section class="section-lg section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-300">
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center">
          <div class="col-lg-4">
            <h2 class="display-3 text-white" style="margin-top: 2.5rem">Let’s talk!</h2>
            <p class="lead text-white">Fill the form and we'll contact you!</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-sm pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Want to contact us?</h4>
              <p class="mt-0">Ask your questions.</p>
              <base-input class="mt-5" alternative addon-left-icon="ni ni-user-run">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="1"
                  cols="80"
                  placeholder="Your name"
                  v-model="name"
                ></textarea>
              </base-input>
              <base-input alternative addon-left-icon="ni ni-email-83">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="1"
                  cols="80"
                  placeholder="Email address"
                  v-model="email"
                ></textarea>
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                  v-model="message"
                ></textarea>
              </base-input>
              <base-button
                type="secondary"
                round
                block
                size="lg"
                @click="sendMail(message, email, name)"
              >
                Send Message
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-sm Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
    sendMail(msg, email, name) {
      if (msg === "" && name === "") {
        window.alert("Fill the form");
        return;
      }
      if (!String(email).includes("@")) {
        window.alert("Invalid e-mail address");
        return;
      }
      AWS.config.update({
        region: process.env.VUE_APP_AWS_REGION,
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
      });
      // Create publish parameters
      var params = {
        Message: `Name: ${name} \nEmail: ${email} \nMessage: ${msg}`,
        TopicArn: "arn:aws:sns:us-east-1:207301203591:SagacaEmail",
      };

      // Create promise and SNS service object
      var publishTextPromise = new AWS.SNS({ apiVersion: "latest" })
        .publish(params)
        .promise();

      // Handle promise's fulfilled/rejected states
      publishTextPromise
        .then(function (data) {
          window.alert("Message sent");
        })
        .catch(function (err) {
          console.error(err, err.stack);
          window.alert("Error while trying to send a message");
        });
      this.message = "";
      this.name = "";
      this.email = "";
    },
  },
};
</script>
